var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 0C.839 0 0 .84 0 1.875 0 2.911.84 3.75 1.875 3.75c1.036 0 1.875-.84 1.875-1.875C3.75.839 2.91 0 1.875 0zm0 6.25C.839 6.25 0 7.09 0 8.125 0 9.161.84 10 1.875 10c1.036 0 1.875-.84 1.875-1.875 0-1.036-.84-1.875-1.875-1.875zm0 6.25C.839 12.5 0 13.34 0 14.375c0 1.036.84 1.875 1.875 1.875 1.036 0 1.875-.84 1.875-1.875 0-1.036-.84-1.875-1.875-1.875zm17.5.625h-12.5c-.345 0-.625.28-.625.625V15c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625v-1.25c0-.345-.28-.625-.625-.625zm0-12.5h-12.5c-.345 0-.625.28-.625.625V2.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V1.25c0-.345-.28-.625-.625-.625zm0 6.25h-12.5c-.345 0-.625.28-.625.625v1.25c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V7.5c0-.345-.28-.625-.625-.625z",
    transform: "translate(2 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8e108748fda7e23f0eeba122b6b6496d.svg";
export { ForwardRef as ReactComponent };